export enum TreasuryTransactionTypeEnum {
  'deposit' = 'deposit',
  'withdrawal' = 'withdrawal',
}
